import React from "react";

const words = [
  "PHP",
  "React",
  "GLPI",
  "Symfony",
  "Laravel",
  "Node.js",
  "TypeScript",
  "SQL",
  "Logiciel libre",
];

function Marquee() {
  const items = [...words, ...words];

  return (
    <div className="marquee-wrap" aria-hidden="true">
      <div className="marquee">
        <div className="marquee-track">
          {items.map((word, idx) => (
            <span key={idx} className="marquee-item">
              {word}
              <span className="marquee-star">✦</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Marquee;
